import { getLogger } from '../logging/functions';
export default getLogger('features/base/audio-only');
